<section class="container flex flex-col gap-6">

  <div class="flex justify-start gap-8 mt-1">
    <button mat-raised-button (click)="searchAgain()" class="ald-mat-button primary w-full md:w-auto px-8">
      {{ "search_again" | i18n }}
    </button>
  </div>

  <div class="list-customer-container">
    <rfc-filter class="w-full block" [filters]="filters" (discardEvent)="search($event)"
      (confirmEvent)="search($event)"></rfc-filter>
  </div>

  <div class="list-customer-container">
    <div class="w-full flex flex-col items-start gap-[20px]">
      <rfc-table class="w-full block h-full" [table]="table" [exportExcel]="true"
        (excelExport)="onExportCustomerList($event)" [page]="this.searchParams?.page"
        (onClickEvent)="selectionCustomer($event)" (onPageChangeEvent)="onPageChangeEvent($event)"
        (onSortSelected)="onSortSelected($event)"></rfc-table>
    </div>
  </div>

</section>